import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeSalaryManual: {},
  },
  mutations: {
    setEmployeeSalaryManual(state, payload) {
      state.employeeSalaryManual = payload
    },
  },
  getters: {
    employeeSalaryManual: (state) => {
      return state.employeeSalaryManual
    },
  },
  actions: {
    onEmployeeSalaryManual({commit, rootState}, {user, project, start, end}) {
      commit('setLoadingAnimationFullPage', true, {root: true})
      let url = rootState.apiDomain + '/api/admin/employee/salary/manual?'
      if (user && user.length)
        for (let i in user)
          url = url + 'user_ids[]=' + user[i] + '&'
      if (project && project.length)
        for (let i in project)
          url = url + 'project_ids[]=' + project[i] + '&'
      if (start) url = url + 'start=' + start + ' 00:00:00&'
      if (end) url = url + 'end=' + end + ' 00:00:00'
      return new Promise((resolve, reject) => {
        axios({url, method: 'GET'})
          .then((resp) => {
            commit('setEmployeeSalaryManual', resp.data)
            commit('setLoadingAnimationFullPage', false, {root: true})
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimationFullPage', false, {root: true})
            reject(err)
          })
      })
    },
    
    onEmployeeSalaryManualClear({commit}) {
      commit('setEmployeeSalaryManual', {})
    }
  }
}
